import { Box } from "@mui/material";
import ClosedBetaData from "../components/ClosedBetaData";
import ClosedBetaInput from "../components/ClosedBetaInput";
import Title from "../components/Title";
import video from '../assets/ClosetIdle.mp4'

const ClosedBetaSection = () => {
  const titleProps = {
    first: "Closed",
    second: "Beta",
  };
  return (
    <div
      id="closed-beta-section-id"
      style={{
        // backgroundImage: "url(images/ClosedBetaBG.jpg)",
        // backgroundSize: "cover",
        // backgroundColor: "#161618",
        // width: "100vw",
        height: "100vh",
      }}
    >
      <div style={{
        // backgroundImage: "url(images/ClosedBetaBG.jpg)",
        // backgroundSize: "cover",
        // backgroundColor: "#161618",
        // width: "100vw",
        height: "100vh",
        position:"absolute",
        width:"100%",
        zIndex:"-2",
      }}>
      <video src={video} autoPlay loop muted id="my-video">
      </video>
      </div>

      <div className="closedBeta-section-content">

        <div className="projects-content-left">
          <div className="title">Closed Beta</div>
          <div className="line"></div>

        </div>
        {/* <Title props={titleProps} /> */}
        <div style={{display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center",alignContent:"center"}}>
        <ClosedBetaData />
          {/* <ClosedBetaInput /> */}

        </div>

      </div>
    </div>
  );
};

export default ClosedBetaSection;
